export const emailRegExp = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,8})+$/;

//export const emailRegExp2 = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;

export function isEmailValid(email) {
    return email.match(emailRegExp);
}
